import { combineReducers } from 'redux';
import user from './user/userReducer';
import chime from './chime/chimeReducer';
import audioVideo from './audioVideo/audioVideoReducer';
import classroom from './classroom/classroomReducer';
import video from './video/videoReducer';
import utils from './utils/utilReducer';
import message from './message/messageReducer';
import moodle from './moodle/moodleReducer';
import conference from './conference/conferenceReducer';

export default combineReducers({
  user,
  audioVideo,
  chime,
  classroom,
  video,
  utils,
  message,
  conference,
  moodle,
});
